import {Modal} from 'src/components/modal/Modal'
import styled from 'styled-components'

export const StyledAssignmentUnscheduleModal = styled(Modal)`
    display: grid;
    grid-template-rows: auto minmax(0, 1fr) auto;
    overflow: hidden;
`
